module.exports = __webpack_public_path__ + "d809c177283f80b7c07380aab4780563.svg";